const EVENTBASEURL="event-api/api/"
const LTBASEURL="lt-api/api/"
// const baseURL ='http://119.84.121.211:20080'; //外网
//const baseURL ='http://www.tyqcn.com/'; //测试
// const baseURL ='http://192.168.3.75:8093'; //测试
// const baseURL =''; //测试
const baseURL3 ='http://192.168.206.47:8082'; //测试
let baseURL = process.env.NODE_ENV === 'development' ? 'http://192.168.206.47:8095' : '../../'; //生产环境;

const URL={
  //EVENTBASEURL
  getStation:EVENTBASEURL+'listSubstation',

  getSelect:EVENTBASEURL+'findMatches',

  //ITBASEURL
  getTypes:LTBASEURL+'listLevelCategory',
  getClass:LTBASEURL+'listTestLevel',
  searchPlayer:LTBASEURL+'queryPerson',
  getPayList:LTBASEURL+'listRegistrationInfoByOrg',        //获取订单

  countMoney:LTBASEURL+'conutOrderMoney',
  saveMoney:LTBASEURL+'addPayOrder',

  savePlayer:LTBASEURL+'putRegistrationInfo',
  putIcRegistrationInfo:LTBASEURL+'putIcRegistrationInfo',

  getCode:'/auth-api/sports-auth/public/sendVcode',   //获取验证码
  toRegister:'/auth-api/sports-auth/public/register',   //去注册
  dologin:'/auth-api/sports-auth/public/dologin',   //登录
  getUserInfo:'/uc-api/sports-uc/platform/getUserInfo',   //获取用户信息

  //个人完善
  savePerson:'/uc-api/sports-uc/platform/completionPersonInfo',   //保存个人
  findLevelByCredentialsNo:'uc-api/sports-uc/platform/findLevelByCredentialsNo',//根据证件号查询等级

  discern:baseURL+'/uc-api/sports-uc/platform/uploadIdCard',   //识别

  saveOrgan: 'uc-api/sports-uc/platform/completionOrgInfo',// 保存组织
  doLogout:'/auth-api/sports-auth/public/logout', //退出

  getPersonMsg: 'uc-api/sports-uc/platform/getPersonInfo',//获取个人用户信息
  getOrganMsg: 'uc-api/sports-uc/platform/getOrgInfo',//获取组织信息

  getAllPayList:'/sports-lt/api/listRegistrationInfo',         //获取所有订单

  saveMoney1:'/sports-lt/api/addPayOrder',         //个人信息点击缴费
  deletePlay:`${LTBASEURL}/deleteRegistrationInfo`,         //个人信息点击删除

  getAllOrderList:'/sports-lt/api/queryOrder',         //获取待支付详情

  deleteOrderStatus:  `${LTBASEURL}/deleteOrderStatus`,         //删除订单

  // 修改密码
  updatePwd: '/auth-api/sports-auth/public/updatePassword',
  // 检查密码
  checkPwd: '/auth-api/sports-auth/public/checkOldPassword',

  // 重置密码
  resetPwd: '/auth-api/sports-auth/public/resetPassword',
  // 找回密码短信验证接口
  sendVcodeForPwd: '/auth-api/sports-auth/public/sendVcodeForPwd',
  judgeFull: '/uc-api/sports-uc/platform/checkIsCompletionInfo',   //判断是否信息完整

  // 等级评分
  searchLevelScore:`${LTBASEURL}/searchLevelScore` ,
  deleteLevelScore:`${LTBASEURL}/deleteLevelScore` ,
  findLevelScoreVo:`${LTBASEURL}/findLevelScoreVo` ,
  updateLevelScore:`${LTBASEURL}/updateLevelScore` ,
  putLevelScore:`${LTBASEURL}/putLevelScore` ,
 // 报名信息
  searchRegistrationInfo:`${LTBASEURL}/searchRegistrationInfo`,
  deleteRegistration:`${LTBASEURL}/deleteRegistration`,
  exportRegistrationInfo:`${LTBASEURL}/exportRegistrationInfo`,
  updateRegistrationInfo:`${LTBASEURL}/updateRegistrationInfo`,
  findRegistration:`${LTBASEURL}/findRegistration`,
  listMatche:`event-api/api/listMatche`,
  //赛事
  findMatchByConditions:`${EVENTBASEURL}/findMatchByConditions`,
  //人员
  searchPerson:'uc-api/sports-uc/searchPerson',
  findPersonInfo:'uc-api/sports-uc/api/findPersonInfo',
  updatePersonInfo:'uc-api/sports-uc/updatePersonInfo',
  addPersonInfo:'uc-api/sports-uc/addPersonInfo',
  deletePersonInfo:'uc-api/sports-uc/deletePersonInfo',
  updateScoreToCfsa:'uc-api/sports-uc/updateScoreToCfsa',
  // 账号
  searchAccount:'uc-api/sports-uc/searchAccount',
  updatePassword:'uc-api/sports-uc/updatePassword',

}

module.exports = URL;



// WEBPACK FOOTER //
// ./src/api/serviceAPI.config.js